function isPageType(pageTypes) {
  const pageType = window.dataLayer?.[0]?.shoptet?.pageType;
  return pageTypes.includes(pageType);
}

const language = dataLayer[0].shoptet.language;

function handleHeader(reload = false) {
  // Add login or account to header
  const navigationButtons = document.querySelector(".navigation-buttons");
  const loginButton =
    document.querySelector(".top-nav-button-account") ||
    document.querySelector(".top-nav-button-login");
  if (navigationButtons && loginButton) {
    navigationButtons.prepend(loginButton);
  }
  const languagesMenu = document.querySelector(".languagesMenu");
  if (languagesMenu && navigationButtons) {
    navigationButtons.prepend(languagesMenu);
  }

  const topNavigationMenu = document.querySelector(".top-navigation-menu");

  const navigation = document.querySelector("#navigation");
  const navigationIn = document.querySelector(".navigation-in");

  const menuHelper = document.querySelector(".menu-helper");

  if (topNavigationMenu && navigation && menuHelper) {
    navigation.append(menuHelper);
    navigation.append(topNavigationMenu);
    if (window.innerWidth < 768) {
      navigationIn.appendChild(topNavigationMenu);
    }
  }
  document.querySelectorAll(".navigation-in li").forEach((li) => {
    const html = li.innerHTML;
    const cleaned = html.replace(/(<\/a>),\s*/g, "$1");
    if (html !== cleaned) {
      li.innerHTML = cleaned;
    }
  });

  function handleMobile() {
    const headerTop = document.querySelector(".header-top");
    const searchBox = document.querySelector(".search");
    const toggleNav = document.querySelector(
      'a.toggle-window[data-target="navigation"]'
    );
    const navigationButtons = document.querySelector(".navigation-buttons");
    const navigation = document.querySelector(".navigation-wrapper");
    if (window.innerWidth < 768) {
      if (headerTop) {
        if (searchBox) headerTop.insertAdjacentElement("afterend", searchBox);
        if (toggleNav) {
          navigationButtons.appendChild(toggleNav);
        }
      }
    } else {
      if (navigationButtons && searchBox) {
        navigationButtons.insertAdjacentElement("beforebegin", searchBox);
      }
      if (toggleNav && navigation) {
        navigation.appendChild(toggleNav);
      }
    }
  }
  handleMobile();
  window.addEventListener("resize", () => {
    handleMobile();
  });
}
handleHeader();
document.addEventListener("ShoptetDOMContentLoaded", function () {
  handleHeader(true);
});

// ! Category Page

function ensureMobileTitle() {
  const list = document.querySelector("ul.subcategories.with-image");
  if (!list) return;

  let title = document.querySelector(".mobile-category-title");
  if (!title) {
    title = document.createElement("h2");
    title.classList.add("mobile-category-title");
    title.textContent = "Podkategorie";
    list.insertAdjacentElement("beforebegin", title);
  }
}

function handleCategory(reload = false) {
  const categoryContentWrapper = document.querySelector("#content-wrapper");

  let categoryTop =
    document.querySelector(".category-top-wrapper .category-top") ||
    document.querySelector("#content .category-top");

  let categoryTopWrapper = document.querySelector(".category-top-wrapper");

  if (reload && categoryTopWrapper) {
    if (!categoryTop) {
      categoryTop = categoryTopWrapper.querySelector(".category-top");
    }
    categoryTopWrapper.remove();
    categoryTopWrapper = null;
  }

  if (!categoryTopWrapper && categoryTop) {
    categoryTopWrapper = document.createElement("div");
    categoryTopWrapper.classList.add("category-top-wrapper");
    categoryTopWrapper.appendChild(categoryTop);
    categoryContentWrapper?.prepend(categoryTopWrapper);
  }

  const subcategories = document.querySelector(".subcategories");
  if (subcategories && !categoryTopWrapper.contains(subcategories)) {
    categoryTopWrapper.appendChild(subcategories);
  }

  if (!document.querySelector(".top-category-header")) {
    const topCategoryText = document.createElement("div");
    topCategoryText.classList.add("top-category-text");

    const topCategoryTitle = document.querySelector(".category-title");

    const topCategoryPerex = document.querySelector(
      ".category-perex:not(.empty-content):not(.empty-content-category)"
    );

    const categoryTopHeader = document.createElement("div");
    categoryTopHeader.classList.add("top-category-header");

    if (topCategoryTitle) {
      topCategoryText.appendChild(topCategoryTitle);
    }
    if (topCategoryPerex) {
      topCategoryText.appendChild(topCategoryPerex);
    }

    categoryTopHeader.appendChild(topCategoryText);
    categoryTop?.prepend(categoryTopHeader);
  }

  const categoryBanner = document.querySelector(".custom-footer__banner13");
  if (categoryBanner && !categoryTopWrapper?.contains(categoryBanner)) {
    document
      .querySelector(".top-category-text")
      ?.insertAdjacentElement("afterend", categoryBanner);
  }
  ensureMobileTitle();

  const sortingForm = document.querySelector("#category-header > form");
  let originalParent = null;
  let originalNextSibling = null;
  let sortingFormWrapper = null;

  const categoryHeaderDiv = document.querySelector(
    "#category-header > div:not([class])"
  );
  if (categoryHeaderDiv) {
    categoryHeaderDiv.classList.add("category-info");
  }

  function moveSortingFormToMobile() {
    if (!sortingForm || sortingFormWrapper) return;

    originalParent = sortingForm.parentNode;
    originalNextSibling = sortingForm.nextSibling;

    sortingFormWrapper = document.createElement("div");
    const sortingFormBtn = document.createElement("button");
    sortingFormBtn.type = "button";

    sortingFormWrapper.append(sortingFormBtn);
    sortingFormWrapper.append(sortingForm);
    sortingFormWrapper.classList.add("sorting-form-wrapper");
    sortingFormBtn.classList.add("sortingBtn");

    let spanHelper = sortingFormBtn.querySelector("span");
    if (!spanHelper) {
      spanHelper = document.createElement("span");
      spanHelper.textContent = "Řazení";
      sortingFormBtn.appendChild(spanHelper);
    }

    const filterBtn = document.querySelector(
      ".other-category-wrapper .filter-btn"
    );
    if (filterBtn) filterBtn.before(sortingFormWrapper);
    else document.querySelector("#category-header").append(sortingFormWrapper);

    sortingFormBtn.addEventListener("click", () => {
      sortingFormWrapper.classList.toggle("active");
    });
  }

  function restoreSortingForm() {
    if (!sortingFormWrapper || !originalParent) return;

    sortingFormWrapper.remove();
    if (originalNextSibling) {
      originalParent.insertBefore(sortingForm, originalNextSibling);
    } else {
      originalParent.appendChild(sortingForm);
    }
    sortingFormWrapper = null;
  }

  function handleResize() {
    if (window.innerWidth < 768) {
      moveSortingFormToMobile();
    } else {
      restoreSortingForm();
    }
  }
  handleResize();
  window.addEventListener("resize", handleResize);

  const filtersWrapper = document.querySelector("#filters-wrapper");
  const categoryHeader = document.querySelector(".category-header");

  function handleMobileLayout() {
    if (window.innerWidth < 768) {
      if (filtersWrapper && categoryHeader) {
        categoryHeader.appendChild(filtersWrapper);
      }
    } else {
      const originalContainer = document.querySelector(".category-top");

      if (originalContainer && subcategories) {
        originalContainer.appendChild(subcategories);
      }
    }
  }

  handleMobileLayout();
  window.addEventListener("resize", handleMobileLayout);
}
function handleProductImage() {
  const products = document.querySelectorAll(".product");
  if (products.length) {
    for (let product of products) {
      const image = product.querySelector(".image > img");
      if (image) {
        image.src = image.src.replace("/detail/", "/orig/");
        if (image.hasAttribute("data-src"))
          image.setAttribute(
            "data-src",
            image.getAttribute("data-src").replace("/detail/", "/orig/")
          );
        if (image.hasAttribute("data-next"))
          image.setAttribute(
            "data-next",
            image.getAttribute("data-next").replace("/detail/", "/orig/")
          );
      }
    }
  }
}
function handleFiltersAndBtn() {
  let unveilBtn = document.querySelector(
    "#filters-wrapper .btn-tertiary.unveil-button.btn"
  );
  const filtersWrapper = document.querySelector("#filters-wrapper");

  if (!unveilBtn) {
    unveilBtn = document.createElement("button");
    unveilBtn.classList.add("btn-tertiary", "unveil-button", "btn");
    unveilBtn.textContent = language === "cs" ? "Filtr" : "Show filter";
    if (filtersWrapper) filtersWrapper.prepend(unveilBtn);

    unveilBtn.addEventListener("click", () => {
      unveilBtn.classList.toggle("active");
    });
  }
}
handleProductImage();
document.addEventListener("ShoptetDOMContentLoaded", handleProductImage);
document.addEventListener("ShoptetDOMPageContentLoaded", handleProductImage);

if (isPageType(["category"])) {
  handleFiltersAndBtn();

  handleCategory();
  document.addEventListener("ShoptetDOMContentLoaded", () => {
    handleCategory(true);
    handleFiltersAndBtn();
  });
  document.addEventListener("ShoptetDOMPageContentLoaded", () => {
    handleCategory(true);
    handleFiltersAndBtn();
  });
  document.addEventListener("ShoptetPageSortingChanged", () => {
    handleCategory(true);
    handleFiltersAndBtn();
  });
  document.addEventListener("ShoptetPageFilterValueChange", () => {
    handleCategory(true);
    handleFiltersAndBtn();
  });

  document.addEventListener("ShoptetPageSortingChanged", handleProductImage);
  document.addEventListener("ShoptetPageFilterValueChange", handleProductImage);
}

// ! Main Page

function handleCarousel() {
  const carousel = document.querySelector("#carousel ");
  if (!carousel || document.querySelector(".carousel-dots")) return;

  const items = carousel.querySelectorAll(".item");
  const observer = new MutationObserver((mutations) => {
    for (let i = 0; i < mutations.length; i++) {
      const target = mutations[i].target;
      if (target.classList.contains("active")) {
        const index = Array.prototype.indexOf.call(items, target);
        const dots = document.querySelectorAll(".carousel-dots li");

        for (let j = 0; j < dots.length; j++) {
          dots[j].classList.toggle("dot-active", j === index);
        }
      }
    }
  });

  const dotsList = document.createElement("ul");
  dotsList.classList.add("carousel-dots");

  for (let i = 0; i < items.length; i++) {
    const dotEl = document.createElement("li");
    if (i === 0) dotEl.classList.add("dot-active");

    dotEl.addEventListener("click", (e) => {
      e.preventDefault();
      const activeItem = carousel.querySelector(".item.active");
      activeItem.classList.remove("active");

      const targetItem = items[i];
      const img = targetItem.querySelector("img");
      if (!img.src) img.src = img.getAttribute("data-src");

      targetItem.classList.add("active");
    });

    observer.observe(items[i], {
      attributes: true,
      attributeFilter: ["class"],
    });
    dotsList.appendChild(dotEl);
  }

  carousel.appendChild(dotsList);
}

if (isPageType(["homepage"])) handleCarousel();

// ! details page

const pInfoWrapper = document.querySelector(".p-info-wrapper");

const handleProductTop = () => {
  const detailInfo = document.querySelector(".p-detail-info");
  const productTitle = document.querySelector(".p-detail-inner-header h1");
  const code = document.querySelector(".p-detail-inner-header .p-code");
  const stars = document.querySelector(".p-detail-info .stars-wrapper");

  if (pInfoWrapper && detailInfo) {
    if (stars) stars.before(productTitle);
    pInfoWrapper.prepend(detailInfo);
    if (code) detailInfo.append(code);
  }
  if (window.innerWidth < 768) {
    const productInfo = document.querySelector(".p-detail-info");
    console.log("productInfo", productInfo);
    if (productInfo) {
      const brand = productInfo.querySelector("div a[href*='/znacka']");
      const brandWrapper = brand?.parentElement;
      const code = productInfo.querySelector(".p-code");
      console.log("brandWrapper", brandWrapper);
      console.log("code", code);
      if (brandWrapper && code) {
        const wrapper = document.createElement("div");
        wrapper.className = "brand-code-wrapper";

        wrapper.appendChild(brandWrapper);
        wrapper.appendChild(code);

        productInfo.insertBefore(wrapper, code.nextSibling);
      }
    }
  }
};

function handleProductVariants() {
  function variantsHandler(id) {
    $(function () {
      if ($(`.variant-list select.parameter-id-${id}`).length) {
        $(`.variant-list select.parameter-id-${id}`).each(function (
          option_index
        ) {
          so_classes = $(this).attr("class");
          so_value = $(this).html();
          so_attr1 = $(this).attr("data-parameter-id");
          so_attr2 = $(this).attr("data-parameter-name");
          so_attr3 = $(this).attr("id");
          so_attr4 = $(this).attr("name");
          so_newLabel = $("<div></div>").html(so_value);
          $(so_newLabel).attr("class", so_classes);
          $(so_newLabel).attr("data-parameter-id", so_attr1);
          $(so_newLabel).attr("data-parameter-name", so_attr2);
          $(so_newLabel).attr("id", so_attr3);
          $(so_newLabel).attr("name", so_attr4);
          $(so_newLabel).attr("value", option_index);
          $(this).replaceWith(so_newLabel);
        });
        if (
          $(`.variant-list:first-of-type .parameter-id-${id} option`).length ==
          1
        ) {
          $(`.variant-list:first-of-type .parameter-id-${id}`).prepend(
            "<option></option>"
          );
        }
        if (
          $(`.variant-list:nth-of-type(2) .parameter-id-${id} option`).length ==
          1
        ) {
          $(`.variant-list:nth-of-type(2) .parameter-id-${id}`).prepend(
            "<option></option>"
          );
        }
        if (
          $(`.variant-list:nth-of-type(3) .parameter-id-${id} option`).length ==
          1
        ) {
          $(`.variant-list:nth-of-type(3) .parameter-id-${id}`).prepend(
            "<option></option>"
          );
        }
        $(`.variant-list .parameter-id-${id} option:first-of-type`).wrap(
          "<span></span>"
        );
        $(
          `.variant-list:first-of-type .parameter-id-${id} span option`
        ).replaceWith(
          '<input type="radio" value name class="variant-default" checked="checked">'
        );
        $(
          `.variant-list:nth-of-type(2) .parameter-id-${id} span option`
        ).replaceWith(
          '<input type="radio" value name class="variant-default" checked="checked">'
        );
        $(
          `.variant-list:nth-of-type(3) .parameter-id-${id} span option`
        ).replaceWith(
          '<input type="radio" value name class="variant-default" checked="checked">'
        );
        $(`.variant-list .parameter-id-${id} option:not(:first-child)`).wrap(
          "<label class='advanced-parameter'></label>"
        );
        $(`.variant-list .parameter-id-${id} label option`).each(function (
          data_index
        ) {
          option_value = $(this).attr("value");
          option_html = $(this).html();
          option_select = $(this).attr("selected");
          option_name = $(this).parents(`.parameter-id-${id}`).attr("name");
          option_newLabel = $("<input>");
          option_newInDiv = $("<span class='parameter-value'></span>").html(
            option_html
          );
          option_newBeDiv = $(
            '<span class="advanced-parameter-inner show-tooltip" title=""></span>'
          );
          option_newApSpan = $('<span class="pkVS"></span>').html(option_html);
          option_data_index = data_index + 1;
          $(option_newLabel).attr("value", option_value);
          $(option_newLabel).attr("name", option_name);
          $(option_newLabel).attr("selected", option_select);
          $(option_newLabel).attr("data-index", option_data_index);
          $(option_newLabel).attr("type", "radio");
          $(this)
            .parents(".hidden-split-parameter")
            .children("span")
            .children("input")
            .attr("name", option_name);
          $(this).after(option_newInDiv);
          $(this).before(option_newBeDiv);
          $(this)
            .parent("label")
            .find(".advanced-parameter-inner")
            .append(option_newApSpan);
          $(this).replaceWith(option_newLabel);
        });
        const selectedInput = document.querySelector(
          'input[selected="selected"]'
        );
        if (selectedInput) {
          selectedInput.checked = true;
          selectedInput.parentElement
            .querySelector(".advanced-parameter-inner")
            .classList.add("yes-before");
        }
      }
    });
  }
  // if (window.innerWidth > 768) {
  const variantListHeading = document.querySelector(
    ".p-info-wrapper .variant-list th"
  );
  if (variantListHeading)
    variantListHeading.textContent =
      language == "cs"
        ? "Vyberte si variantu:"
        : language == "sk"
        ? "Vyberte si variantu:"
        : "Pick a variant:";

  let detailParametersVariants = document.querySelectorAll(
    ".detail-parameters td > select"
  );
  if (detailParametersVariants.length) {
    detailParametersVariants.forEach((variant) => {
      if (variant.hasAttribute("data-parameter-id")) {
        let variantId = variant.getAttribute("data-parameter-id");
        if (variantId) {
          variantsHandler(variantId);
        }
      }
    });
  }

  const productAppendix = document.querySelector(
    ".p-detail-inner .product-appendix"
  );
  const tbodyDetailParameters = document.querySelector(
    ".p-info-wrapper table.detail-parameters tbody"
  );
  if (productAppendix && tbodyDetailParameters) {
    console.log("appendix");

    tbodyDetailParameters.innerHTML = `
		<tr class="variant-list">
            <td>
				<label class="advanced-parameter">
				<span class="advanced-parameter-inner show-tooltip yes-before" title="" data-original-title="">
				<span class="pkVS">${productAppendix.textContent}</span>
				</span><input value="" type="radio" checked="checked">
				<span class="parameter-value">${productAppendix.textContent}</span>
				</label>
            </td>
        </tr>
		`;
  }
  const availabilityBlocks = document.querySelectorAll(
    ".availability-value .parameter-dependent"
  );
  availabilityBlocks.forEach((block) => {
    const isSoldOut = block.textContent.trim().includes("Vyprodáno");
    const classList = Array.from(block.classList);
    const sizeClass = classList.find((cls) => cls.startsWith("5-"));
    if (isSoldOut && sizeClass) {
      const sizeId = sizeClass.split("-")[1];
      const input = document.querySelector(
        `input[type="radio"][value="${sizeId}"]`
      );
      if (input) {
        const label = input.closest("label.advanced-parameter");
        if (label) {
          label.classList.add("unavailable");
        }
      }
    }
  });
}
function handleProductDetailPhoto() {
  const elements = document.querySelectorAll(
    "a[href], img[src], img[data-src]"
  );

  elements.forEach((el) => {
    if (el.hasAttribute("href")) {
      el.href = el.href
        .replace("/big/", "/orig/")
        .replace("/related/", "/orig/");
    }
    if (el.hasAttribute("src")) {
      el.src = el.src.replace("/big/", "/orig/").replace("/related/", "/orig/");
    }
    if (el.hasAttribute("data-src")) {
      el.setAttribute(
        "data-src",
        el
          .getAttribute("data-src")
          .replace("/big/", "/orig/")
          .replace("/related/", "/orig/")
      );
    }
    if (el.hasAttribute("data-href")) {
      el.setAttribute(
        "data-href",
        el
          .getAttribute("data-href")
          .replace("/big/", "/orig/")
          .replace("/related/", "/orig/")
      );
    }
  });
}
function handleProductDetail() {
  // Availability
  const availabilityValue = document.querySelector(".availability-value ");
  const delivery = document.querySelector(
    ".detail-parameters tr:last-child th"
  );

  if (availabilityValue && delivery) delivery.prepend(availabilityValue);

  // Price
  const priceQuantityWrapper = document.createElement("div");
  priceQuantityWrapper.classList.add("price-quantity-wrapper");

  const priceWrapper = document.querySelector(".p-final-price-wrapper");

  const quantity = document.querySelector(".p-detail .add-to-cart .quantity");

  const addToCartWrapper = document.querySelector(".p-detail .add-to-cart ");

  if (priceWrapper && quantity && addToCartWrapper) {
    priceQuantityWrapper.appendChild(priceWrapper);
    priceQuantityWrapper.appendChild(quantity);

    priceQuantityWrapper.classList.add("price-quantity-wrapper");
    addToCartWrapper.prepend(priceQuantityWrapper);
  }

  const imagesProductWrapper = document.querySelector(".p-image-wrapper");
  const shpTabsWrapper = document.querySelector(".shp-tabs-wrapper");
  const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
  let wrapperDiv = document.querySelector(".product-image-tabs-wrapper");

  if (imagesProductWrapper && shpTabsWrapper) {
    if (!wrapperDiv) {
      wrapperDiv = document.createElement("div");
      wrapperDiv.classList.add("product-image-tabs-wrapper");
      imagesProductWrapper.parentNode.insertBefore(
        wrapperDiv,
        imagesProductWrapper
      );
    }

    wrapperDiv.appendChild(imagesProductWrapper);
    wrapperDiv.appendChild(shpTabsWrapper);
    if (breadcrumbs) {
      wrapperDiv.prepend(breadcrumbs);
    }
  }

  const contentWrapper = document.getElementById("content-wrapper");
  contentWrapper.classList.remove("container");

  let productSwiper = null;
  let originalStructure = null;

  function initProductSwiper() {
    const productImage = document.querySelector(
      ".product-image-tabs-wrapper .p-image-wrapper"
    );
    const pImage = productImage?.querySelector(".p-image");

    if (window.innerWidth <= 767) {
      const thumbnails = document.querySelectorAll(".p-thumbnail");

      if (
        thumbnails.length &&
        productImage &&
        !document.querySelector(".product-swiper")
      ) {
        if (!originalStructure && pImage) {
          originalStructure = pImage.cloneNode(true);
        }

        const swiperContainer = document.createElement("div");
        swiperContainer.classList.add("swiper", "product-swiper");

        const swiperWrapper = document.createElement("div");
        swiperWrapper.classList.add("swiper-wrapper");

        const mainImageLink = document.querySelector(
          ".p-image > a.p-main-image"
        );
        if (mainImageLink) {
          const firstSlide = document.createElement("div");
          firstSlide.classList.add("swiper-slide");

          const clonedLink = mainImageLink.cloneNode(true);
          firstSlide.appendChild(clonedLink);
          swiperWrapper.appendChild(firstSlide);

          thumbnails.forEach((thumb, index) => {
            if (index > 0) {
              const imgUrl = thumb.getAttribute("href");
              const slide = document.createElement("div");
              slide.classList.add("swiper-slide");

              const aEl = document.createElement("a");
              aEl.classList.add("p-main-image");
              aEl.href = imgUrl;

              const imgEl = document.createElement("img");
              imgEl.src = imgUrl;

              aEl.appendChild(imgEl);
              slide.appendChild(aEl);
              swiperWrapper.appendChild(slide);
            }
          });
        }

        const navigation = document.createElement("div");
        navigation.classList.add("swiper-navigation");
        navigation.innerHTML = `
          <div class="swiper-button-prev"></div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-next"></div>
        `;

        swiperContainer.appendChild(swiperWrapper);
        swiperContainer.appendChild(navigation);

        if (pImage) {
          pImage.innerHTML = "";
          pImage.appendChild(swiperContainer);

          productSwiper = new Swiper(".product-swiper", {
            slidesPerView: 1.3,
            spaceBetween: 16,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        }
      }
    } else {
      if (productSwiper) {
        productSwiper.destroy(true, true);
        productSwiper = null;
      }

      if (originalStructure && pImage) {
        pImage.innerHTML = originalStructure.innerHTML;
      }
    }
  }

  initProductSwiper();

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initProductSwiper();
    }, 250);
  });

  const flagsExtra = document.querySelector(".flags.flags-extra");
  const flagsDefault = document.querySelector(".flags.flags-default");
  if (flagsExtra && flagsDefault) {
    flagsDefault.appendChild(flagsExtra);
  }
}
function handleProductTopMobile() {
  console.log(window.innerWidth);
  if (window.innerWidth < 769) {
    console.log("mobile");
    const container = document.querySelector(
      ".product-image-tabs-wrapper .p-image-wrapper"
    );
    container.insertAdjacentElement("afterend", pInfoWrapper);
  }
}

if (isPageType(["productDetail"])) {
  document.addEventListener("DOMContentLoaded", handleProductVariants);
  handleProductTop();
  handleProductDetail();
  handleProductDetailPhoto();
  handleProductTopMobile();
  handleProductVariants();

  document.addEventListener(
    "ShoptetDOMContentLoaded",
    handleProductDetail,
    handleProductDetailPhoto,
    handleProductTopMobile
  );
  document.addEventListener(
    "ShoptetVariantAvailable",
    handleProductDetailPhoto,
    handleProductDetail,
    handleProductTopMobile
  );
  window.addEventListener("resize", handleProductTopMobile);
}

// ! CART PAGE

let originalBackButtonParent = null;

function handleCartPage() {
  const discountWrapper = document.querySelector(".discount-coupon");
  const deliveryWrapper = document.querySelector(".extra.delivery");
  const priceWrapper = document.querySelector(".price-wrapper");

  if (discountWrapper && deliveryWrapper && priceWrapper) {
    priceWrapper.insertAdjacentElement("afterend", deliveryWrapper);
    priceWrapper.insertAdjacentElement("beforebegin", discountWrapper);
  }

  const buttonBack = document.querySelector(".btn.next-step-back");
  if (buttonBack && !originalBackButtonParent) {
    originalBackButtonParent = buttonBack.parentElement;
  }

  const buttonLoginCart = document.querySelector(
    ".in-krok-2 .co-contact-information .btn.btn-secondary"
  );
  if (buttonLoginCart) {
    buttonLoginCart.classList.remove("btn-secondary");
    buttonLoginCart.classList.add("btn-default");
  } else {
    console.warn("Button .btn-secondary not found");
  }

  const btnsDelete = document.querySelectorAll("tr.removeable .remove-item");

  btnsDelete.forEach((btn) => {
    const span = btn.querySelector("span");
    if (span) {
      span.classList.remove("sr-only");
      span.textContent = "Odstranit";
    }
  });
}

function moveBackButtonOnResize() {
  const buttonBack = document.querySelector(".btn.next-step-back");
  const cartContent = document.querySelector(".cart-content");

  console.log(
    "buttonBack",
    buttonBack,
    "originalBackButtonParent",
    originalBackButtonParent
  );
  if (!buttonBack || !originalBackButtonParent || !cartContent) return;

  if (window.innerWidth > 1060) {
    if (buttonBack.parentElement !== cartContent) {
      cartContent.appendChild(buttonBack);
    }
  } else {
    if (buttonBack.parentElement !== originalBackButtonParent) {
      originalBackButtonParent.prepend(buttonBack);
    }
  }
}

if (isPageType(["cart", "billingAndShipping", "customerDetails", "thankYou"])) {
  handleCartPage();
  moveBackButtonOnResize();
  window.addEventListener("resize", moveBackButtonOnResize);
  handleProductDetailPhoto();

  const events = [
    "ShoptetDOMContentChanged",
    "ShoptetDOMCartCountUpdated",
    "ShoptetCartSetCartItemAmount",
    "ShoptetCartUpdated",
    "ShoptetDOMContentLoaded",
    "ShoptetDOMCartContentLoaded",
    "ShoptetCartAddDiscountCoupon",
  ];

  events.forEach((event) => {
    document.addEventListener(event, handleCartPage);
    document.addEventListener(event, moveBackButtonOnResize);
  });
  document.addEventListener("ShoptetCartUpdated", handleProductDetailPhoto);
}
